import { render, staticRenderFns } from "./TradesFilter.vue?vue&type=template&id=5ef1d5d5&"
import script from "./TradesFilter.vue?vue&type=script&lang=js&"
export * from "./TradesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports